import { useNavigate, useParams } from "react-router-dom";
import { useBoardUrlRedirect } from "../hooks/useBoardUrlRedirect";

/**
 * BoardUrlController - A controller component that handles backward compatibility for board URLs
 * 
 * This controller detects if a URL contains a numeric board_id (old format)
 * and redirects to the new URL format using the board key.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when redirection isn't needed
 * @returns {React.ReactNode} - Either children or null during redirection
 */
const BoardUrlController = ({ children }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  useBoardUrlRedirect({ id, navigate });

  return children;
};

export default BoardUrlController;
